import { Observable } from 'rxjs';
import AxiosSubscriber from '../../factory/AxiosSubscriber';

export class ReadSingleNotificationAPI {
  constructor() {
    this.subscription = null;
  }

  subscribe(messageId, data, next, complete, error) {
    const token = localStorage.getItem("token");

    const httpConfig = {
      url: `/message/${messageId}/read`,
      method: 'put',
      data: data,
      headers: {
        'accept': 'application/json',
        'Content-Type': `application/json`,
        'Authorization': `Bearer ${token}`
      }
    };

    let observable$ = new Observable((observer) => {
      return new AxiosSubscriber(observer, httpConfig);
    });

    this.subscription = observable$.subscribe({
      next: next,
      complete: complete,
      error: error
    });
  }

  unsubscribe() {
    if (this.subscription !== undefined && this.subscription !== null) {
      this.subscription.unsubscribe();
    }
  }
}